// src/services/fcmService.js
import { getToken } from "firebase/messaging";
import { messaging } from "./firebase";

const VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY;

export async function getFCMToken() {
  const permission = await Notification.requestPermission();
  if (permission === "denied")  throw new Error("PERMISSION_DENIED");
  if (permission === "default") throw new Error("PERMISSION_DISMISSED");
  const token = await getToken(messaging, { vapidKey: VAPID_KEY });
  if (!token) throw new Error("TOKEN_UNAVAILABLE");
  return token;
}

export function getErrorMessage(code) {
  const map = {
    PERMISSION_DENIED:    "Notification permission was blocked. Please allow notifications in your browser settings, then reload the page.",
    PERMISSION_DISMISSED: "You need to grant notification permission to use this app. Please click 'Allow' when prompted.",
    TOKEN_UNAVAILABLE:    "Could not get a device token. Use Chrome, Edge, or Firefox and try again.",
    UNREGISTERED_DEVICE:  "This device is not registered with any company. Please contact your administrator.",
    DEVICE_DEACTIVATED:   "This device has been deactivated. Please contact your administrator.",
    COMPANY_INACTIVE:     "This company account is inactive. Please contact support.",
    COMPANY_EXPIRED:      "This company's subscription has expired. Please contact support.",
  };
  return map[code] ?? "An unexpected error occurred. Please try again.";
}
